<template>
  <div class="top-bar-msg">
    <div class="settings-wrapper">
      <div class="tab-wrapper tab-wrapper-messages">
        <router-link
          id="media_tagging_main_tab"
          :to="{ name: 'Media tagging main tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 9C13.5 8.70333 13.588 8.41332 13.7528 8.16665C13.9176 7.91997 14.1519 7.72771 14.426 7.61418C14.7001 7.50065 15.0017 7.47094 15.2926 7.52882C15.5836 7.5867 15.8509 7.72956 16.0607 7.93934C16.2704 8.14912 16.4133 8.41639 16.4712 8.70736C16.5291 8.99834 16.4994 9.29994 16.3858 9.57403C16.2723 9.84811 16.08 10.0824 15.8334 10.2472C15.5867 10.412 15.2967 10.5 15 10.5C14.6022 10.5 14.2206 10.342 13.9393 10.0607C13.658 9.77936 13.5 9.39782 13.5 9ZM22.125 5.25V18.75C22.125 19.2473 21.9275 19.7242 21.5758 20.0758C21.2242 20.4275 20.7473 20.625 20.25 20.625H3.75C3.25272 20.625 2.77581 20.4275 2.42417 20.0758C2.07254 19.7242 1.875 19.2473 1.875 18.75V5.25C1.875 4.75272 2.07254 4.27581 2.42417 3.92417C2.77581 3.57254 3.25272 3.375 3.75 3.375H20.25C20.7473 3.375 21.2242 3.57254 21.5758 3.92417C21.9275 4.27581 22.125 4.75272 22.125 5.25ZM4.125 5.625V13.0988L7.29938 9.92438C7.65099 9.57287 8.12782 9.3754 8.625 9.3754C9.12218 9.3754 9.59901 9.57287 9.95062 9.92438L13.8103 13.7812L15.4209 12.1716C15.7726 11.8201 16.2494 11.6226 16.7466 11.6226C17.2437 11.6226 17.7206 11.8201 18.0722 12.1716L19.875 13.9772V5.625H4.125ZM4.125 18.375H15.2194L8.625 11.7806L4.125 16.2806V18.375ZM19.875 18.375V17.1562L16.7466 14.0278L15.4012 15.375L18.4012 18.375H19.875Z"
              fill="#373C44"
            />
          </svg>
          <span class="tab-btn-msg-text">Media</span>
        </router-link>
        <router-link
          id="media_tagging_tab"
          :to="{ name: 'Media tagging tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.8103 12.75L13.5 3.43969C13.3612 3.2998 13.196 3.18889 13.014 3.11341C12.832 3.03792 12.6368 2.99938 12.4397 3.00001H3.75001C3.5511 3.00001 3.36033 3.07903 3.21968 3.21968C3.07903 3.36033 3.00001 3.5511 3.00001 3.75001V12.4397C2.99938 12.6368 3.03792 12.832 3.11341 13.014C3.18889 13.196 3.2998 13.3612 3.43969 13.5L12.75 22.8103C12.8893 22.9496 13.0547 23.0602 13.2367 23.1356C13.4187 23.211 13.6138 23.2498 13.8108 23.2498C14.0078 23.2498 14.2029 23.211 14.3849 23.1356C14.5669 23.0602 14.7323 22.9496 14.8716 22.8103L22.8103 14.8716C22.9496 14.7323 23.0602 14.5669 23.1356 14.3849C23.211 14.2029 23.2498 14.0078 23.2498 13.8108C23.2498 13.6138 23.211 13.4187 23.1356 13.2367C23.0602 13.0547 22.9496 12.8893 22.8103 12.75ZM13.8103 21.75L4.50001 12.4397V4.50001H12.4397L21.75 13.8103L13.8103 21.75ZM9.00001 7.87501C9.00001 8.09751 8.93403 8.31502 8.81041 8.50002C8.68679 8.68503 8.51109 8.82922 8.30553 8.91437C8.09996 8.99952 7.87376 9.0218 7.65553 8.97839C7.4373 8.93498 7.23685 8.82784 7.07951 8.6705C6.92218 8.51317 6.81503 8.31271 6.77162 8.09448C6.72822 7.87626 6.75049 7.65006 6.83564 7.44449C6.92079 7.23892 7.06499 7.06322 7.24999 6.9396C7.435 6.81599 7.6525 6.75001 7.87501 6.75001C8.17338 6.75001 8.45952 6.86853 8.6705 7.07951C8.88148 7.29049 9.00001 7.57664 9.00001 7.87501Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Tags</span>
        </router-link>
        <router-link
          id="media_tagging_comments_tab"
          :to="{ name: 'Media tagging comments tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9C8.80109 9.75 8.61032 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9ZM9 12.75H15C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12C15.75 11.8011 15.671 11.6103 15.5303 11.4697C15.3897 11.329 15.1989 11.25 15 11.25H9C8.80109 11.25 8.61032 11.329 8.46967 11.4697C8.32902 11.6103 8.25 11.8011 8.25 12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM12 14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H12C12.1989 15.75 12.3897 15.671 12.5303 15.5303C12.671 15.3897 12.75 15.1989 12.75 15C12.75 14.8011 12.671 14.6103 12.5303 14.4697C12.3897 14.329 12.1989 14.25 12 14.25ZM21 4.5V14.6897C21.0006 14.8867 20.9621 15.082 20.8866 15.264C20.8111 15.446 20.7002 15.6112 20.5603 15.75L15.75 20.5603C15.6112 20.7002 15.446 20.8111 15.264 20.8866C15.082 20.9621 14.8867 21.0006 14.6897 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM4.5 19.5H14.25V15C14.25 14.8011 14.329 14.6103 14.4697 14.4697C14.6103 14.329 14.8011 14.25 15 14.25H19.5V4.5H4.5V19.5ZM15.75 15.75V18.4406L18.4397 15.75H15.75Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Comments</span>
        </router-link>
        <router-link
          id="media_tagging_pinned_tab"
          :to="{ name: 'Media tagging pinned tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.4948 8.37733L15.6237 3.50664C15.5045 3.38735 15.3629 3.29272 15.2071 3.22816C15.0513 3.1636 14.8843 3.13037 14.7156 3.13037C14.5469 3.13037 14.3799 3.1636 14.2241 3.22816C14.0683 3.29272 13.9267 3.38735 13.8074 3.50664L9.50302 7.82508C8.64743 7.55698 6.69387 7.2335 4.65524 8.87981C4.51472 8.99281 4.39957 9.13414 4.31729 9.29459C4.23501 9.45505 4.18743 9.63104 4.17767 9.8111C4.1679 9.99116 4.19616 10.1713 4.2606 10.3397C4.32505 10.5081 4.42423 10.6611 4.5517 10.7886L8.42993 14.6656L5.00598 18.0874C4.8855 18.2079 4.81781 18.3713 4.81781 18.5417C4.81781 18.7121 4.8855 18.8756 5.00598 18.996C5.12646 19.1165 5.28987 19.1842 5.46026 19.1842C5.63065 19.1842 5.79405 19.1165 5.91454 18.996L9.33608 15.5718L13.2119 19.448C13.331 19.5676 13.4726 19.6626 13.6285 19.7275C13.7844 19.7924 13.9516 19.8258 14.1205 19.826C14.1509 19.826 14.1806 19.826 14.2111 19.826C14.3942 19.8133 14.5724 19.7614 14.7336 19.6737C14.8948 19.5861 15.0352 19.4647 15.1454 19.3179C16.7217 17.2229 16.57 15.5196 16.204 14.5018L20.4956 10.1938C20.6148 10.0745 20.7094 9.93285 20.7739 9.77699C20.8384 9.62112 20.8715 9.45408 20.8714 9.2854C20.8714 9.11672 20.8381 8.9497 20.7734 8.7939C20.7088 8.63809 20.6141 8.49654 20.4948 8.37733ZM19.5862 9.28597L14.9897 13.8982C14.8948 13.9935 14.8321 14.1162 14.8107 14.249C14.7892 14.3818 14.81 14.5179 14.8701 14.6383C15.6294 16.1578 14.7256 17.7358 14.1205 18.5409L5.46026 9.87915C6.42981 9.09734 7.35764 8.89105 8.06714 8.89105C8.51735 8.8849 8.96384 8.97322 9.37781 9.15031C9.49858 9.21076 9.63534 9.23159 9.76863 9.20983C9.90191 9.18807 10.0249 9.12483 10.1202 9.02911L14.716 4.41447L19.5862 9.28516V9.28597Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Priorities</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  name: 'MediaTaggingNavigationPanel',
  computed: {
    ...mapGetters('mediaTagging', {})
  },
};
</script>
<style scoped>
.tab-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-width: 310px;
  width: auto;
  min-height: 35px;
  margin-right: 20px;
  border-radius: 79px;
  border: 1px solid var(--case-btn-border-color);
}

.top-bar-msg {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  background: #FFFFFF;
  box-shadow: none;
  max-width: 770px;
  width: 100%;
}

.tab-btn-msg-text {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-text-color);
  transition: 0.3s all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-btn-msg.active .tab-btn-msg-text,
.tab-btn-msg:hover .tab-btn-msg-text {
  color: var(--secondary-black-color);
}

.tab-btn-msg.active svg path,
.tab-btn-msg:hover svg path,
.tab-btn-msg.active .highlight g > :not(:first-child),
.tab-btn-msg:hover .highlight g > :not(:first-child) {
  fill: var(--secondary-black-color);
}

.tab-btn-msg.active .highlight path,
.tab-btn-msg:hover .highlight path {
  fill: var(--white-color);
}

.settings-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-wrapper {
  padding-bottom: 28px;
}

.tab-btn-msg {
  width: 50%;
  max-height: 35px;
  padding: 10px 30px 10px 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s all;
  gap: 5px;
}

.tab-btn-msg svg path {
  fill: var(--secondary-text-color);
}

.tab-wrapper-messages {
  border: none;
}
</style>